import React, {useEffect, useState} from 'react';
import {TextField, Autocomplete} from '@mui/material';
import {Controller} from "react-hook-form";
import debounce from 'lodash/debounce'
import {workspaceActions} from "../../store/actions/workspaceAction";
import {connect} from "react-redux";

function WorkspaceDropdown(
    {
        workspace,
        control,
        workspaceId,
        setValue,
        validate = null,
    }
) {

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (!open) {
            setSearch("");
        }
    }, [open]);

    useEffect(() => {
        if (parseInt(workspaceId) > 0 && workspace?.userWorkspaces !== null) {
            workspace?.userWorkspaces.forEach((item) => {
                if (workspaceId === item?.workspaceId) {
                    setValue("workspace", {value: item?.workspaceId, label: item?.name});
                }
            });
        }
    }, [workspace?.userWorkspaces, control, workspaceId, setValue])

    useEffect(() => {
        if (workspace?.userWorkspaces !== null) {
            let data = [];
            workspace?.userWorkspaces.forEach((item) => {
                data.push({value: item?.workspaceId, label: item?.name});
            });
            setOptions(data);
        }
    }, [workspace?.userWorkspaces]);

    const handleSearch = debounce(searchTerm => {
        setSearch(searchTerm);
    }, 800);

    return (
        <Controller
            render={({field: {onChange, ...props}, fieldState}) => (
                <Autocomplete
                    id="workspace-dropdown"
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => {
                        if (value?.value === 0) {
                            return true;
                        }
                        return option.value === value.value
                    }}
                    getOptionLabel={(option) => option.label}
                    options={options}
                    loading={workspace?.loading?.getUserWorkspaces}
                    renderInput={params => (
                        <TextField
                            autoFocus
                            {...params}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            variant="outlined"
                            margin="dense"
                            size="small"
                            placeholder="Select a workspace"
                            label="Workspace*"
                            fullWidth
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                }
                            }}
                            value={search}
                            onChange={e => handleSearch(e.target.value)}
                        />
                    )}
                    onChange={(e, data) => onChange(data)}
                    {...props}
                />
            )}
            rules={{
                required: "Workspace is required.",
                validate: validate || undefined,
            }}
            name="workspace"
            control={control}
            defaultValue={null}
        />
    );
}

const mapStateToProps = (state) => {
    return {
        workspace: state.workspace
    }
};

const actionCreators = {
    getUserWorkspaces: workspaceActions.getUserWorkspaces
};

export default connect(mapStateToProps, actionCreators)(WorkspaceDropdown);